import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss'
import {BrowserRouter as Router} from "react-router-dom";
import App from './App';
import {Provider} from "react-redux";
import {setupStore} from "./store/store";

const store = setupStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>
);
